<div class="fixed-nav">
  <img src="https://dev.app.swayam.cloud/assets/img/swayam_logo_v3.0.svg" alt="">
</div>